<script>
    import { fade } from 'svelte/transition';
    import {link , push } from 'svelte-spa-router'
    import fetchData from '../api.js';
    import { systemUrl } from '../api.js';
    import { validateFields }  from '../base/validation.js';
    import { send_iframe_data }  from '../base/shipments.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount ,onDestroy } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte'; 
    import Preloader from '../components/Preloader.svelte'; 
    import { silentPrint }  from '../base/printer.js';

    let isLoading = true; 
    let print_url = '';
    let scannedBarcode = '';
    let showA4StartPositionPopup = false;
    let a4StartPosition = 1;
    let a4PendingPrintLink = '';
    

    export let params; 
    
    let likut = false;
    if (typeof params.likut!=='undefined') {
        likut = true;
    }
    let single_items = false;
    if (params?.tab == "4") {
        single_items = true;
    }



    
    let tracking_number = false;
    let orders = {};

    $: {
        
        if (shipment.destination.shipment_type==2) {          
            getStores(postData)            
        }
    }

    $: location_id = shipment.destination.datalogics_location;


    const getStores = async () => {

        let postData = {};
        postData.platform_id = shipment.destination.datalogics_platform_id;
        postData.action = 'crm_stores_by_platform';
        postData.token = $UserStore.data

        let response = await fetchData(postData);

        //console.log('response',response);

        if (response.data) {

            //stores = response.data; 

            const keyValueArray = Object.entries(response.data);

            // Sort the array by keys
            keyValueArray.sort((a, b) => a[0].localeCompare(b[0]));

            // Convert the sorted array back to an object
            stores = Object.fromEntries(keyValueArray);

            if (Object.keys(orders).length>0) {

                for(let order_id in orders) {
                
                    if (orders[order_id].destination.datalogics_n_code!='') {
                        for(let key in stores) {
                            stores[key].filter((store)=> {
                                console.log(store.n_code)
                                if (store.n_code == orders[order_id].destination.datalogics_n_code) {
                                    orders[order_id].destination.datalogics_n_code_city = store.city
                                }
                            })
                        }
                    }

                }

            }

        }
    }    

    let stores = [];
    let settings = {};
    let general_settings = {};
    let shipping_methods = [];
    let locations = [];
    let selected_shipping_method = {}
    let items = {}
    


    let shipment = {
        status_code : 0,
        external_id : '',
        shipping_method : '',
        order_status : '',
        status : [],
        items : [],
        shipment_id : '',
        order_name : '',
        platform_id : '',
        order_id : '',
        general_comments : '',
        reference : '',
        origin : {
            // fullname : '',
            // phone : '',
            // email : '',
            // city : '',
            // address : '',
            // house : '',
            // entrance : '',
            // apartment : '',
            // floor : '',
            // door : '',
            comments : ''
        },
        destination : {
            datalogics_fullname : '',
            datalogics_phone : '',
            datalogics_email : '',
            datalogics_city : '',
            datalogics_address : '',
            datalogics_house : '',
            datalogics_entrance : '',
            datalogics_apartment : '',
            datalogics_floor : '',
            datalogics_door : '',
            datalogics_shipment_type : "1",
            datalogics_shipment_select : "1",
            datalogics_package_type : "1",
            datalogics_govina_sum : '',
            datalogics_comments : '',
            datalogics_n_code : '',
            datalogics_n_code_city : '',
            datalogics_n_code_auto : false,
            datalogics_platform_id : '',
            datalogics_reference : '',
            datalogics_location : 0,
            datalogics_packs : 1,
            datalogics_weight : ''
            
        }
    }

    
    onMount(async() => {

        console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }   
        
        getShipments();        
        
        document.addEventListener('keydown', handleKeyDown);        
    })


    onDestroy(() => {
        document.removeEventListener('keydown', handleKeyDown);
    });

    async function getShipments() {

        locations = $UserStore.settings?.shipping_settings?.datalogics_update_inventory_locations ?? []

        print_url = systemUrl + '/label?token=' + $UserStore.data;        
        print_url += "&order_ids=";

        settings = $UserStore.settings.shipping_settings;
        general_settings = settings;

        if (settings.shipping_method && settings.shipping_method.length) {
            shipping_methods = settings.shipping_method;
            selected_shipping_method = shipping_methods[0]
        } else {
            shipping_methods = [];
        }  

        

        shipment.destination.datalogics_platform_id = selected_shipping_method.shipping_push_supplier; 
      
        
        if (params && params.shipments_ids) {

            
            let shipments_ids = params.shipments_ids.split(",");
            //console.log(shipments_ids)
            await Promise.all(shipments_ids.map(async(order_id) => {

                let postData = {};   

                postData.action = 'crm_get_shipment';
                postData.token = $UserStore.data                
                postData.shipment_id = order_id
                if (likut){
                    postData.details = 1;
                }
                let response = await fetchData(postData);

                if (response.data) {

                    let shipping_data = response.data[0];

                    let iFrameObject = {
                        area : shipping_data.area,
                        line_number : shipping_data.line_number,
                        tracking_number : shipping_data.shipment_id,
                        label_url : shipping_data.label,
                        platform_id : shipping_data.platform_id,
                        date : shipping_data.date,
                        platform_name : shipping_data.platform_name,
                        success : 1,
                        order_id : shipping_data.order_id,
                        ncode_details : shipping_data.ncode_details,
                        ncode : shipping_data.ncode,
                        msg : ''                    
                    }   

                    send_iframe_data(iFrameObject)

                    //console.log('shipping_data',shipping_data)

                    //console.log('shipment',shipment)

                    let order = JSON.parse(JSON.stringify(shipment));

                    if (order.platform_id) {
                        order.destination.datalogics_platform_id = shipping_data.platform_id;
                    }

                    order.shipment_id = shipping_data.shipment_id;
                    order.order_name = shipping_data.order_name;
                    order.order_id = shipping_data.order_id;
                    order.created_at = shipping_data.date || new Date().toISOString();
                    //shipment.platform_id = shipping_data.platform_id
                    order.destination.datalogics_packs = shipping_data.packages;
                    order.destination.datalogics_weight = shipping_data.weight;
                    order.destination.datalogics_fullname = shipping_data.client_name;
                    order.destination.datalogics_phone = shipping_data.client_phone;
                    order.destination.datalogics_email = shipping_data.client_email;
                    order.destination.datalogics_city = shipping_data.client_city;
                    order.destination.datalogics_address = shipping_data.client_street;
                    order.destination.datalogics_house = shipping_data.client_house;
                    order.destination.datalogics_entrance = shipping_data.client_entrance;
                    order.destination.datalogics_apartment = shipping_data.client_apartment;
                    order.destination.datalogics_floor = shipping_data.client_floor;
                    order.destination.datalogics_door = shipping_data.shipping_door;
                    order.destination.datalogics_shipment_type = shipping_data.shipment_type;
                    order.destination.datalogics_shipment_select = "1";
                    order.destination.datalogics_govina_sum = '';
                    order.destination.datalogics_comments = shipping_data.comments;
                    order.destination.datalogics_n_code = (shipping_data.ncode!='') ?  (shipping_data.ncode) : '';
                    order.destination.datalogics_n_code_city = '';
                    order.destination.datalogics_location = 0;
                    order.destination.datalogics_reference = shipping_data.order_name;
                    order.items = shipping_data.items;

                    if (order.destination.datalogics_n_code!='' && order.destination.datalogics_n_code!=null) {
                        order.destination.datalogics_shipment_select = "2";
                    }

                    if (shipping_data.items) {

                        console.log(order.shipment_id)

                        if (likut && order?.shipment_id!=null) {
                            return;
                        }

                        shipping_data.items.filter((item)=>{

                            var sku = item.sku;
                            var name = item.name;
                            var barcode = item.barcode;

                            if (items[sku]) {
                                items[sku].quantity += parseInt(item.quantity);
                            } else {
                                items[sku] = {
                                    order_id : order.order_id,
                                    name : name,
                                    sku: sku,
                                    barcode: barcode,
                                    quantity: parseInt(item.quantity),
                                    quantity_scanned: 0,
                                    scanned_status: 0,
                                    inventory: item.inventory || [],
                                };
                            }
                        });

                    }

                    orders[order_id] = order;

                }


            }));


            if ([3512,"3512"].indexOf($UserStore.id)!==-1) {
                handleSubmit();
            }
            

        }

        getStores()

        isLoading = false; 

    }

    async function processOrdersSequentially() {

        isLoading = true;

        const sortedOrderKeys = Object.keys(orders).sort((a, b) => a - b); 

        console.log('sortedOrderKeys',sortedOrderKeys,orders)


        for (let order_id of sortedOrderKeys) {
            if (!validateFields(orders[order_id].destination)) {
                alert('יש למלא את כל השדות חובה');
                continue;
            }

            let postData = {};
            postData.action = 'crm_create_shipment';
            postData.token = $UserStore.data;
            postData.order_id = order_id;

            orders[order_id].destination.datalogics_platform_id = shipment.destination.datalogics_platform_id; 
            orders[order_id].destination.datalogics_location = shipment.destination.datalogics_location;
            postData.data = orders[order_id].destination;


            try {
                let response = await fetchData(postData);
                console.log('handleSubmit', response);

                // If the response contains data, update the order with the shipment_id
                if (response.data) {

                    let iFrameObject = response.data
                    send_iframe_data(iFrameObject)

                    orders[order_id].shipment_id = response.data.shipment_id;
                }
            } catch (error) {
                console.error(`Error processing order ${order_id}:`, error);
            }
        }

        isLoading = false;

    }

    const handleSubmit =  async () => {
        await processOrdersSequentially();
    }

    const BulkPrint = () => {

        const orderIdsWithShipment = [];
        Object.keys(orders).forEach(orderId => {
            if (orders[orderId].shipment_id) {
                orderIdsWithShipment.push(orderId);
            }
        });

        let link = print_url + orderIdsWithShipment.join(",");

        if (shippingo=="1") {
            link += "&shippingo=1";
        }

        if (isA4PaperSelected()) {
            a4PendingPrintLink = link;
            a4StartPosition = 1;
            showA4StartPositionPopup = true;
            return;
        }

        window.open(link, '_blank');

    }

    function isA4PaperSelected() {
        const paperType = settings?.shipping_label_paper_type ?? general_settings?.shipping_label_paper_type;
        return paperType === 'a4';
    }

    function getA4LabelsPerRow() {
        const rawValue = settings?.shipping_label_a4_labels_per_row ?? general_settings?.shipping_label_a4_labels_per_row ?? '2';
        const parsed = parseInt(rawValue, 10);
        return [2, 3, 4].includes(parsed) ? parsed : 2;
    }

    function getA4CellsCount() {
        return 20;
    }

    function closeA4StartPositionPopup() {
        showA4StartPositionPopup = false;
        a4PendingPrintLink = '';
    }

    function confirmA4StartPositionAndPrint() {
        if (!a4PendingPrintLink) {
            showA4StartPositionPopup = false;
            return;
        }

        let link = a4PendingPrintLink;
        link += '&paper_type=a4';
        link += '&labels_per_row=' + getA4LabelsPerRow();
        link += '&start_position=' + a4StartPosition;

        window.open(link, '_blank');
        showA4StartPositionPopup = false;
        a4PendingPrintLink = '';
    }


    function handleItemsScannCount(barcodeKey) {


        items[barcodeKey].quantity_scanned++;
        if (items[barcodeKey].quantity_scanned>=items[barcodeKey].quantity) {
            items[barcodeKey].scanned_status = 2;
            items[barcodeKey].quantity_scanned = items[barcodeKey].quantity;
        } else {
            items[barcodeKey].scanned_status = 1;
        }

        items = {...items}

    }

    async function printLikut(){
            
        let shipments_ids = params.shipments_ids.split(",");

        let postData = {};
        postData.action = 'crm_print_orders_items';
        postData.token = $UserStore.data;
        postData.get = 1;
        postData.order_id = shipments_ids;

        let itemsURL = systemUrl + 'crm_print_orders_items?token=' + $UserStore.data;
        if (single_items) {
            itemsURL += '&multi=1'
        }
        itemsURL += '&orders_id='+shipments_ids;

        if ($UserStore.id==2353 || $UserStore.id==91) {

            console.log('inside'+$UserStore.id,$UserStore.settings.shipping_settings.printer)

            silentPrint(itemsURL,$UserStore.settings.shipping_settings.printer);

        } else {

            window.open(itemsURL, '_blank');

        }

        // try {
        //     let response = await fetchData(postData);
        //     if (response.data) {
                
        //     }
        // } catch (error) {
        //     console.error(`Error processing order ${order_id}:`, error);
        // }

    }


    function handleKeyDown(event) {

        // if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.isContentEditable) {
        //     return;
        // }

        // Check if the key pressed is a number or Enter
        if (/^[a-zA-Z0-9]$/.test(event.key)) {

            scannedBarcode += event.key;

        } else if (event.key === 'Enter') {

            console.log('scannedBarcode',scannedBarcode)

            if (scannedBarcode.startsWith('E')) {
                scannedBarcode = scannedBarcode.substring(1);
            }

            //alert(scannedBarcode);

            let barcodePassed = false;
            let barcodeKey = '';

            

            for (let order_id in orders) {
                for (let key in orders[order_id].items) { // Assuming orders[order_id] has 'items'
                    if (
                        orders[order_id].items[key].barcode == scannedBarcode || 
                        orders[order_id].items[key].sku == scannedBarcode
                    ) {
                        barcodePassed = true;
                        barcodeKey = key;

                        if (single_items) {
                            push(`/shipment/${order_id}`);
                            return;
                        }                        
                        break;
                    }
                }
                
            }                   
                
            

            if (!barcodePassed) {
                // Handle the case when the note does not exist
                alert('ברקוד אינו קיים ברשימה');
                scannedBarcode = '';
                return;
            }

            scannedBarcode = '';

            handleItemsScannCount(barcodeKey)
            
        }
    }

    async function DownloadXls(){


        const slip_url = systemUrl + '/xls_packingslip?token=' + $UserStore.data + "&order_id=" + params.shipments_ids;;
        console.log('slip_url',slip_url)
        const printWindow = window.open(slip_url, '_blank');

    }

    function handlePlatformChange(event) {
        shipment.destination.datalogics_platform_id = event.target.value;
        getStores();
        console.log(event.target.value)
    }

    function updateAllOrdersShipmentType(value) {
        orders = Object.fromEntries(
            Object.entries(orders).map(([key, order]) => [
                key,
                {
                    ...order,
                    destination: {
                        ...order.destination,
                        datalogics_shipment_type: value
                    }
                }
            ])
        );
    }

    function createWaveFromSelected() {
        const shipmentsIds = String(params?.shipments_ids || '').trim();
        const currentTab = String(params?.tab || '1').trim();

        if (!shipmentsIds) {
            alert('No selected orders found.');
            return;
        }

        push(`/bins/sorter/create/${shipmentsIds}/${currentTab}`);
    }

</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>

        {#if showA4StartPositionPopup}
        <div class="fixed top-0 bottom-0 left-0 right-0 m-auto z-50 flex flex-col items-center justify-center bg-black bg-opacity-50">
            <div class="bg-white shadow-lg p-4 relative max-w-[760px] w-[95%] rounded-[8px]">
                <button type="button" class="absolute top-[10px] left-[10px] cursor-pointer text-[20px]" on:click={closeA4StartPositionPopup}>X</button>
                <h2 class="text-[20px] font-bold mt-[10px] mb-[10px]">{$_('shipment.a4_start_position_title')}</h2>
                <div class="mb-[10px]">{$_('shipment.a4_start_position_desc')}</div>
                <div class="a4-grid" style={`grid-template-columns: repeat(${getA4LabelsPerRow()}, minmax(0, 1fr));`}>
                    {#each Array(getA4CellsCount()) as _, index}
                    <button
                        type="button"
                        class="a4-cell"
                        class:a4-cell-selected={a4StartPosition === index + 1}
                        on:click={() => a4StartPosition = index + 1}
                    >
                        {index + 1}
                    </button>
                    {/each}
                </div>
                <div class="a4-popup-actions">
                    <button type="button" class="a4-popup-btn a4-popup-btn-cancel" on:click={closeA4StartPositionPopup}>{$_('shipment.a4_start_position_cancel')}</button>
                    <button type="button" class="a4-popup-btn a4-popup-btn-confirm" on:click={confirmA4StartPositionAndPrint}>{$_('shipment.a4_start_position_confirm')}</button>
                </div>
            </div>
        </div>
        {/if}
        <div class="shipment">            
            <h1 class="text-[20px] font-bold">
                {#if shipment.order_id}
                    {$_('shipment.order_name')}: {shipment.order_name} {#if shipment.order_name!=shipment.order_id}({shipment.order_id}){/if}
                {:else}
                    {$_('shipment.shipment_name')}
                {/if}
            </h1>  
            
            {#if !locations[location_id]}
                <div>
                    {$_('shipment.locations_msg')}
                    <a class="link" use:link href="/locations">{$_('shipment.edit_locations')}</a>
                </div>
            {:else}
                {#if shipping_methods.length>1}
                <div class="shipping_companies">
                    <label>{$_('companies.shipping_company')}</label>
                    <select bind:value={shipment.destination.datalogics_platform_id}  on:change={handlePlatformChange}>
                    {#each shipping_methods as method}
                        {#if platforms && platforms[+method.shipping_push_supplier] && platforms[+method.shipping_push_supplier]?.name!=''}
                            <option value="{method.shipping_push_supplier}">{platforms[+method.shipping_push_supplier].name}</option>
                        {/if}
                    {/each}
                    </select>
                </div>      
                {/if}
                {#if (Object.keys(items).length && ((settings.enable_scanning_products && settings.enable_scanning_products=="1") || (general_settings.enable_scanning_products && general_settings.enable_scanning_products=="1")))}
                <div class="shipment-items">
                    <div class="shipment_header flex justify-between">
                        <div><i class="fa-solid fa-barcode"></i> {$_('items.items')}</div>
                        {#if likut}
                        <div class="flex">
                            <div on:click={createWaveFromSelected} class="bg-color text-white text-[14px] rounded-[15px] p-1 px-3 mx-1 cursor-pointer">{$_('bins.common.create_wave')}</div>
                            <div on:click={()=>DownloadXls()} class="bg-color text-white text-[14px] rounded-[15px] p-1 px-3 mx-1 cursor-pointer">{$_('orders.download_likut_xls')}</div>
                            <div on:click={()=>printLikut()} class="bg-color text-white text-[14px] rounded-[15px] p-1 px-3 cursor-pointer">{$_('orders.print_likut_items')}</div>
                            {#if printers.length}
                            <div>                        
                                <select bind:value={settings.printer} class="text-black p-1">
                                    {#each printers as printer}
                                        <option value={printer}>{printer}</option>
                                    {/each}
                                </select>                        
                            </div>
                            {/if}   
                        </div>      
                        {/if}              
                    </div> 
                    <div class="shipment-items-box">
                        <div class="shipment-items-line shipment-items-line-head">
                            <div>{$_('items.sku')}</div>
                            <div>{$_('items.barcode')}</div>
                            <div>{$_('items.name')}</div>
                            <div>{$_('items.qty')}</div>
                            <div>{$_('items.qty_scanned')}</div>
                            <div>{$_('items.scanned_status')}</div>
                        </div>
                        {#each Object.keys(items) as item,key}
                        <div class="shipment-items-line">
                            <div>
                                <div>{items[item].sku}</div>
                                {#if items[item].inventory && items[item].inventory.length}
                                <div>
                                    <div class="flex">
                                        {#each items[item].inventory as inventory,inventory_key}
                                        <div class="p-2 bg-slate-100 rounded mx-1" class:bg-slate-300={([69,70,79,1].indexOf(inventory.store_id)!==-1)}>{$_('items.store')}:{inventory.store_id} {$_('items.qty')}:{inventory.quantity}</div>
                                        {/each}
                                    </div>
                                </div>
                                {/if}
                            </div>
                            <div>
                                {#if items[item].barcode==undefined}
                                    -
                                {:else}
                                    {items[item].barcode}
                                {/if}
                            </div>
                            <div>{items[item].name}</div>
                            <div><div class="qty">{items[item].quantity}</div></div>
                            <div><div class="qty qty-scanned">{items[item].quantity_scanned}</div></div>
                            <div>
                                <div class="badge badge{items[item].scanned_status}" on:click={()=> { handleItemsScannCount(items[item].sku) } }>
                                {#if items[item].scanned_status==0}
                                    {$_('items.not_scanned')}
                                {:else if items[item].scanned_status==1}
                                    {$_('items.partial_scanned')}
                                {:else}
                                    {$_('items.scanned')}
                                {/if}
                                </div>
                            </div>
                        </div>
                        {/each}
                    </div>
                </div>
                {/if}
                {#if !likut}
                <div class="shipment-flex">
                    <div class="shipment_origin">
                        <div class="shipment_header">
                            <i class="fa-regular fa-map"></i> {$_('shipment.origin')}
                        </div>   
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.location_name')} <a class="link" use:link href="/locations">{$_('shipment.edit_locations')}</a></label>      
                                <select bind:value={shipment.destination.datalogics_location}>
                                {#each locations as location,index}
                                    {#if location.enabled}
                                    <option value="{index}">{location.name} - {location.street} {location.house} , {location.city} </option>
                                    {/if}
                                {/each}
                                </select>
                            </div>
                        </div>
                        <div class="input_box">      
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.name')}</label>
                                <input type="text" bind:value={locations[location_id].name} disabled>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.phone')}</label>
                                <input type="text" bind:value={locations[location_id].phone} disabled>
                            </div>             
                            <div class="input_con">
                                <label>{$_('shipment.email')}</label>
                                <input type="text" bind:value={locations[location_id].email} disabled>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                <input type="text" bind:value={locations[location_id].city} disabled>
                            </div>
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.street')}</label>
                                <input type="text" bind:value={locations[location_id].street} disabled>
                            </div>
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.house')}</label>
                                <input type="text" bind:value={locations[location_id].house} disabled>
                            </div>
                        </div>
                        <!-- 
                        <div class="input_box">
                            
                            <div class="input_con">
                                <label>{$_('shipment.entrance')}</label>
                                <input type="text" bind:value={shipment.origin.entrace}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.floor')}</label>
                                <input type="text" bind:value={shipment.origin.floor}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.apartment')}</label>
                                <input type="text" bind:value={shipment.origin.apartment}>
                            </div>
                        </div>
                         -->
                        <!-- <div class="input_box">
                            <div class="input_con">
                                <label>{$_('shipment.origin_comments')}</label>
                                <input type="text" bind:value={shipment.origin.comments}>
                            </div>                    
                        </div> -->
                    </div>
                    <div class="shipment_destination">
                        <div class="shipment_header">
                            <i class="fa-solid fa-location-dot"></i> {$_('shipment.destination')}
                        </div> 
                    {#each Object.keys(orders) as order_key,index } 
                        {#if !orders[order_key].open}

                            {#if orders[order_key].shipment_id}
                                <div class="shipment_notification">
                                    {orders[order_key].order_name} {$_('shipment.your_tracking_number_created')} 
                                    <a href="{print_url}{orders[order_key].order_id}" target="_blank">
                                        <i class="fa-solid fa-print red-color"></i> 
                                        <strong>{orders[order_key].shipment_id}</strong>
                                        {$_('shipment.print_click_here')} 
                                    </a>
                                </div>            
                            {:else}
                                <div class="shipment_destination_closed" on:click={()=> { orders[order_key].open = true } }>
                                    <div>
                                    {orders[order_key].order_name} 
                                    {orders[order_key].destination.datalogics_fullname}
                                    {orders[order_key].destination.datalogics_city}
                                    {orders[order_key].destination.datalogics_address}
                                    </div>
                                    <div>
                                        <i class="fa-solid fa-chevron-down"></i>
                                    </div>
                                </div>
                            {/if}
                        {:else}
                        <div class="shipment_destination_key">
                            <div class="shipment_destination_closed shipment_destination_open" on:click={()=> { orders[order_key].open = false } }>
                                <div>
                                {orders[order_key].order_name} 
                                </div>
                                <div>
                                    <i class="fa-solid fa-chevron-up"></i>
                                </div>
                            </div>
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.shipping_type')}</label>      
                                    <select bind:value={orders[order_key].destination.datalogics_shipment_type}>
                                        <option value="1"> {$_('shipment.delivery')}</option>
                                        <option value="2"> {$_('shipment.double_govina')}</option>
                                        <option value="3"> {$_('shipment.pickup')}</option>
                                    </select>
                                </div>
                                {#if orders[order_key].destination.datalogics_shipment_type=="2"}
                                <div class="input_con">
                                    <label>{$_('shipment.govina_sum')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_govina_sum}>
                                </div>
                                {/if}
                                <div class="input_con">
                                    <label>{$_('shipment.packages')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_packs}>
                                </div>
                                <div class="input_con">
                                    <label>{$_('shipment.weight')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_weight}>
                                </div> 
                            </div>
                            <div class="input_box">      
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.name')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_fullname} class:input_empty_error={orders[order_key].destination.datalogics_fullname === ''}>
                                </div>
                            </div>
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.phone')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_phone} class:input_empty_error={orders[order_key].destination.datalogics_phone === ''}>
                                </div>             
                                <div class="input_con">
                                    <label>{$_('shipment.email')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_email}>
                                </div>
                            </div>
                            {#if Object.keys(stores).length && platforms[orders[order_key].destination.datalogics_platform_id] && platforms[orders[order_key].destination.datalogics_platform_id].pickup && platforms[shipment.destination.datalogics_platform_id].pickup=="1"}
                            <div class="input_box">
                                <div class="input_con radio">
                                    <input id="shipment_type1" type="radio" name="shipment_type" bind:group={orders[order_key].destination.datalogics_shipment_select} value="1">
                                    <label for="shipment_type1"><i class="fa-solid fa-asterisk"></i> {$_('shipment.specific_location')}</label>
                                </div>
                                <div class="input_con radio">
                                    <input id="shipment_type2" type="radio" name="shipment_type" bind:group={orders[order_key].destination.datalogics_shipment_select}  value="2">
                                    <label for="shipment_type2"><i class="fa-solid fa-asterisk"></i> {$_('shipment.pudo')}</label>
                                </div>
                            </div>
                            {/if}
                            {#if orders[order_key].destination.datalogics_shipment_select==1}
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_city} class:input_empty_error={orders[order_key].destination.datalogics_city === ''}>
                                </div>
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.street')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_address} class:input_empty_error={orders[order_key].destination.datalogics_address === ''}>
                                </div>
                            </div>
                            <div class="input_box">
                                <div class="input_con">
                                    <label>{$_('shipment.house')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_house}>
                                </div>
                                <div class="input_con">
                                    <label>{$_('shipment.entrance')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_entrance}>
                                </div>
                                <div class="input_con">
                                    <label>{$_('shipment.floor')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_floor}>
                                </div>
                                <div class="input_con">
                                    <label>{$_('shipment.apartment')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_apartment}>
                                </div>
                            </div>
                            {:else}
                                <div class="input_box flex flex-col items-start gap-1 mt-5">
                                    <div class="font-bold">{$_('shipment.customer_address')}</div>
                                    <div>{$_('shipment.customer_address_note')}</div>
                                </div>
                                <div class="input_box">
                                    <div class="input_con">
                                        <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                        <input type="text" bind:value={orders[order_key].destination.datalogics_city} class:input_empty_error={orders[order_key].destination.datalogics_city === ''}>
                                    </div>
                                    <div class="input_con">
                                        <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.street')}</label>
                                        <input type="text" bind:value={orders[order_key].destination.datalogics_address} class:input_empty_error={orders[order_key].destination.datalogics_address === ''}>
                                    </div>
                                </div>
                                {#if orders[order_key].destination.datalogics_city!=''}
                                <div class="input_box">
                                    <div class="input_con radio checkbox text-center mt-[0px]">                                
                                        <input type="checkbox" id="auto" bind:checked={orders[order_key].destination.datalogics_n_code_auto}>
                                        <label for="auto"><span></span></label>
                                        <span class="p-1 px-3">
                                            {$_('shipment.auto_select_ncode_based_on_shipping_location')} 
                                            <strong>
                                            {#if orders[order_key].destination.datalogics_address!=''}
                                                {orders[order_key].destination.datalogics_address} {orders[order_key].destination.datalogics_house} ,
                                            {/if}
                                            {orders[order_key].destination.datalogics_city}
                                            </strong>
                                        </span>
                                    </div>
                                </div>
                                {/if}
                                {#if orders[order_key].destination.datalogics_n_code_auto==false}
                                <div class="input_box flex flex-col items-start gap-1 mt-5 font-bold">
                                    {$_('shipment.pudo_location_title')}
                                </div>
                                <div class="input_box">
                                    <div class="input_con">
                                        <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                        <select bind:value={orders[order_key].destination.datalogics_n_code_city}>
                                            <option value="">יש לבחור עיר</option>
                                            {#each Object.keys(stores) as item,index}
                                                <option value="{item}">{item}</option>
                                            {/each}
                                        </select>
                                    </div>
                                    <div class="input_con">
                                        <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.podu_location')}</label>
                                        <select bind:value={orders[order_key].destination.datalogics_n_code}>
                                            <option value="">יש לבחור ממס</option>
                                            {#if orders[order_key].destination.datalogics_n_code_city!='' && stores[orders[order_key].destination.datalogics_n_code_city].length}
                                                {#each stores[orders[order_key].destination.datalogics_n_code_city] as item,index}
                                                    <option value="{item.n_code.toString()}">{item.name} - {item.street} {item.house}</option>
                                                {/each}
                                            {/if}
                                        </select>
                                    </div>
                                    
                                </div>
                                {/if}  
                            {/if}                          
                        </div>                        
                        {/if}
                    {/each}   
                    </div>         
                </div>      
                <div class="orders-bulk-con flex items-center">
                    <div class="button flex items-center gap-1" >
                        <div on:click={()=>{ handleSubmit(); }}><div class="bg-red-100 text-black rounded-[5px] p-1 px-3">{$_('shipment.create_shipment')}</div></div>
                        <div class="input_con flex flex-row">   
                            <select on:change={(e) => updateAllOrdersShipmentType(e.target.value)} class="text-black p-1 h-[30px]">
                                <option value="1">{$_('shipment.delivery')}</option>
                                <option value="2">{$_('shipment.double_govina')}</option>
                                <option value="3">{$_('shipment.pickup')}</option>
                            </select>
                        </div>
                    </div>
                    <!-- <div class="button" on:click={()=> BulkPrint() }>{$_('shipment.print')}</div> -->
                    <div class="button" on:click={()=> BulkPrint() }>
                        {$_('shipment.print')}
                    </div>
                    {#if printers.length}
                    <div class="button">                        
                        <select bind:value={settings.printer} class="text-black p-1">
                            {#each printers as printer}
                                <option value={printer}>{printer}</option>
                            {/each}
                        </select>                        
                    </div>
                    {/if}                    
                </div>
                {/if} 
            {/if}
        </div>
    </div>
</div>

<style>   

    .shipment-items-box {
        display: table;
        width:100%;
        font-size: 14px;;
    }
    .shipment-items-line-head {
        font-weight: bold;
    }
    .shipment-items-line {
        display:table-row;
        width: 100%;        
    }
    .shipment-items-line > div {
        display:table-cell;
        border-bottom:1px solid rgb(171 171 171);  
        border-bottom:1px solid rgb(226, 226, 226);  
        padding:4px;
        border-collapse: collapse;;
        text-align: center;
    }

    .qty {
        background-color: #5b5b5b;
        color: white;
        border-radius: 5px;;
        padding:5px;
        display: inline-block;
        width: 20px;;
        text-align: center;
    }
    .qty-scanned {
        background-color: #262626;
    }
    .badge {
        width: 90px;
        background-color: #60a325;
        color: white;
        border-radius: 5px;;
        padding:5px 10px;
        display: inline-block;
    }
    .badge0 {
        background-color: var(--theme-one-color);
    }
    .badge1 {
        background-color: #234fe0;
    }

    .a4-grid {
        display: grid;
        gap: 8px;
        max-height: 50vh;
        overflow: auto;
        padding: 4px;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        background: #f8fafc;
    }

    .a4-cell {
        border: 1px solid #cbd5e1;
        background: white;
        border-radius: 6px;
        min-height: 48px;
        font-weight: 700;
        cursor: pointer;
    }

    .a4-cell-selected {
        background: #1f2937;
        color: white;
        border-color: #1f2937;
    }

    .a4-popup-actions {
        margin-top: 14px;
        display: flex;
        justify-content: flex-end;
        gap: 8px;
    }

    .a4-popup-btn {
        min-width: 120px;
        padding: 8px 14px;
        border-radius: 8px;
        border: 1px solid transparent;
        font-weight: 700;
        cursor: pointer;
    }

    .a4-popup-btn-cancel {
        background: #f3f4f6;
        border-color: #d1d5db;
        color: #111827;
    }

    .a4-popup-btn-confirm {
        background: #111827;
        border-color: #111827;
        color: white;
    }

    
    .shipment-flex {
        text-align: center;
        display: flex;  
    }
    
    .shipment-flex > div {
        flex:1;
        padding:10px;
    }
    
    .shipment_header {
        color: var(--theme-one-color);
        padding: 10px 0;
        margin-bottom: 20px;
        /* border-radius: 10px; */
        font-size: 22px;
        text-align: right;
        border-bottom: 1px solid rgb(171 171 171);
    }
    
    
    .shipment_header i {
        color: rgb(73 73 73)
    }

    .shipment_notification {
        padding:10px;
        border:1px solid green;
        background-color: rgb(228, 255, 228);
        border-radius:10px;
        margin-bottom: 10px;
        font-size: 14px;;
    }

    .shipment_destination {
        flex-direction:column;
        display:flex;
    }

    .shipment_destination_closed {
        margin-top:24px;
        text-align: right;
        background-color: var(--theme-one-color);
        color:#fff;
        border:0;
        border-radius: 7px;;
        padding:10px;
        font-size: 14px;;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
    
    }
    .shipment_destination_open {
        background-color: var(--theme-one-color);
        border:0;
        color:#fff;
    }

    @media screen and (max-width:600px) {
        .shipment-flex {
            text-align: center;
            display: flex;  
            flex-direction: column;
        }
    }

</style>